import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

//@ts-ignore
export function cn(...inputs) {
  let twMerge
  try {
    twMerge = require("tailwind-merge").twMerge
  } catch (e) {
    return inputs.join(" ")
  }
  let clsx
  try {
    clsx = require("clsx").clsx
  } catch (e) {
    return inputs.join(" ")
  }
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency: string = 'BGN', locale: string = 'bg-BG'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(amount);
}

// Calculate the discount for subscription items
export function calculateSubscriptionDiscount(price: number, isPickup: boolean = false): number {
  // Apply 15% discount for all subscriptions
  let discountedPrice = price * 0.85;

  // Apply additional 5% discount if pickup is selected
  if (isPickup) {
    discountedPrice = price * 0.80; // Total 20% discount (15% + 5%)
  }

  return discountedPrice;
}

// Calculate the percentage discount for display purposes
export function getSubscriptionDiscountPercentage(isPickup: boolean = false): number {
  return isPickup ? 20 : 15;
}

import { PrismaClient, SubscriptionFrequency, SubscriptionStatus } from "@prisma/client";

// Use the global prisma instance pattern
const globalForPrisma = global as unknown as { prisma: PrismaClient };
export const prisma = globalForPrisma.prisma || new PrismaClient();

if (process.env.NODE_ENV !== "production") globalForPrisma.prisma = prisma;

// Format delivery frequency for display
export function formatDeliveryFrequency(frequency: SubscriptionFrequency): string {
  switch (frequency) {
    case SubscriptionFrequency.WEEKLY:
      return 'Всяка седмица';
    case SubscriptionFrequency.BI_WEEKLY:
      return 'На две седмици';
    case SubscriptionFrequency.MONTHLY:
      return 'Всеки месец';
    default:
      return 'По график';
  }
}

// Get the delivery interval in days for a given frequency
export function getDeliveryIntervalDays(frequency: SubscriptionFrequency): number {
  switch (frequency) {
    case SubscriptionFrequency.WEEKLY:
      return 7;
    case SubscriptionFrequency.BI_WEEKLY:
      return 14;
    case SubscriptionFrequency.MONTHLY:
      return 30;
    default:
      return 30;
  }
}

// Calculate the next delivery date based on frequency
export function calculateNextDeliveryDate(frequency: SubscriptionFrequency, startDate: Date = new Date()): Date {
  const result = new Date(startDate);
  result.setDate(result.getDate() + getDeliveryIntervalDays(frequency));
  return result;
}

// Format subscription status for display
export function formatSubscriptionStatus(status: SubscriptionStatus): string {
  switch (status) {
    case 'ACTIVE':
      return 'Активен';
    case 'PAUSED':
      return 'Приостановен';
    case 'CANCELLED':
      return 'Отменен';
    case 'FAILED':
      return 'Неуспешен';
    case 'COMPLETED':
      return 'Приключен';
    default:
      return 'Неизвестно';
  }
} 